import './resultado.scss'

const resultado = ({ checkResumo, indicadores, nls }) => {
  if (!checkResumo) return null

  const listaIndicadores = Array.isArray(indicadores) ? indicadores : []

  const obterStatusCheck = status => {
    if (status === 'aguardando_finalizacao') return nls.checkStatusPending
    if (status === 'finalizado') return nls.checkStatusFinished
    if (status === 'rejeitado') return nls.checkStatusRejected
    return status || ''
  }

  const adicionarPercentual = valor => {
    if (valor === null || valor === undefined || valor === '') return null

    const texto = String(valor).trim()

    if (texto.endsWith('%')) {
      return texto
    }

    return `${texto}%`
  }

  const removerPercentual = valor => {
  if (valor === null || valor === undefined || valor === '') return null

  return String(valor).trim().replace(/%$/, '')
}

  const obterPeriodoCheck = () => {
    const dataInicio = checkResumo?.data_inicio || ''
    const dataFinal = checkResumo?.data_final || ''

    if (dataInicio && dataFinal) {
      return `${dataInicio} - ${dataFinal}`
    }

    if (dataInicio) return dataInicio
    if (dataFinal) return dataFinal

    return null
  }

  const cardsResumo = [
    {
      key: 'status',
      label: nls.checkStatusLabel,
      value: checkResumo?.status ? obterStatusCheck(checkResumo.status) : null,
      highlight: false
    },
    {
      key: 'periodo',
      label: nls.checkPeriodLabel,
      value: obterPeriodoCheck(),
      highlight: false
    },
    {
      key: 'qtd-plan',
      label: nls.problemCommentsPlanLabel,
      value:
        checkResumo?.qtd_comentarios_problema_plan !== null &&
        checkResumo?.qtd_comentarios_problema_plan !== undefined
          ? checkResumo.qtd_comentarios_problema_plan
          : null,
      highlight: false
    },
    {
      key: 'qtd-check',
      label: nls.problemCommentsCheckLabel,
      value:
        checkResumo?.qtd_comentarios_problema_check !== null &&
        checkResumo?.qtd_comentarios_problema_check !== undefined
          ? checkResumo.qtd_comentarios_problema_check
          : null,
      highlight: false
    },
    {
      key: 'ganho-nps',
      label: nls.refactoredNpsGainLabel,
      value:
        checkResumo?.ganho_nps_refatorado !== null &&
        checkResumo?.ganho_nps_refatorado !== undefined &&
        checkResumo?.ganho_nps_refatorado !== ''
          ? checkResumo.ganho_nps_refatorado
          : null,
      highlight: true
    },
    {
      key: 'melhoria',
      label: nls.problemImprovementPercentageLabel,
      value:
        checkResumo?.melhoria_percentual_problema !== null &&
        checkResumo?.melhoria_percentual_problema !== undefined &&
        checkResumo?.melhoria_percentual_problema !== ''
          ? adicionarPercentual(checkResumo.melhoria_percentual_problema)
          : null,
      highlight: true
    },
    {
      key: 'freq-check',
      label: nls.problemFrequencyCheckPerDayLabel,
      value:
        checkResumo?.freq_problema_check_por_dia !== null &&
        checkResumo?.freq_problema_check_por_dia !== undefined &&
        checkResumo?.freq_problema_check_por_dia !== ''
          ? removerPercentual(checkResumo.freq_problema_check_por_dia)
          : null,
      highlight: true
    },
    {
      key: 'freq-plan',
      label: nls.problemFrequencyPlanPerDayLabel,
      value:
        checkResumo?.freq_problema_plan_por_dia !== null &&
        checkResumo?.freq_problema_plan_por_dia !== undefined &&
        checkResumo?.freq_problema_plan_por_dia !== ''
          ? removerPercentual(checkResumo.freq_problema_plan_por_dia)
          : null,
      highlight: true
    }
  ].filter(item => item.value !== null)

  return (
    <div
  className='resultado'
  data-cy='pdca-plan-detail-result'
>
      <div className='resultado__title'>
        {nls.resultTitle.toUpperCase()}
      </div>

      <div className='resultado__content'>
        {cardsResumo.length > 0 && (
          <div
  className='resultado__summary-cards'
  data-cy='pdca-plan-detail-result-summary'
>
            {cardsResumo.map(item => (
              <div
  key={item.key}
  className='resultado__summary-card'
  data-cy='pdca-plan-detail-result-summary-item'
  data-cy-key={item.key}
>
                <span className='resultado__label'>
                  {item.label}
                </span>
                <strong className={`resultado__value ${item.highlight ? 'resultado__value--highlight' : ''}`}>
                  {item.value}
                </strong>
              </div>
            ))}
          </div>
        )}

        {listaIndicadores.length > 0 && (
          <div
  className='resultado__indicators'
  data-cy='pdca-plan-detail-result-indicators'
>
            <div className='resultado__indicators-title'>
              {nls.indicatorsTitle}
            </div>

            <div className='resultado__table-wrapper'>
              <table className='resultado__table'>
                <thead>
                  <tr>
                    <th>{nls.indicatorNameLabel}</th>
                    <th>{nls.planFrequencyLabel}</th>
                    <th>{nls.checkFrequencyLabel}</th>
                    <th>{nls.improvementLabel}</th>
                  </tr>
                </thead>
                <tbody>
                  {listaIndicadores.map((item, index) => (
                    <tr
  key={`resultado-indicador-${index}`}
  data-cy='pdca-plan-detail-result-indicator'
>
                      <td>{item?.nome || ''}</td>
                      <td>
                        {item?.frequencia_plan !== null &&
                        item?.frequencia_plan !== undefined &&
                        item?.frequencia_plan !== ''
                          ? removerPercentual(item.frequencia_plan)
                          : ''}
                      </td>
                      <td>
                        {item?.frequencia_check !== null &&
                        item?.frequencia_check !== undefined &&
                        item?.frequencia_check !== ''
                          ? removerPercentual(item.frequencia_check)
                          : ''}
                      </td>
                      <td>
                        {item?.melhoria !== null &&
                        item?.melhoria !== undefined &&
                        item?.melhoria !== ''
                          ? adicionarPercentual(item.melhoria)
                          : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default resultado